import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { WorkSection } from "@/components/WorkSection";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Portfolio() {
  const lenisRef = useRef(null);
  const workRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);
  const [clientFilter, setClientFilter] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  const scrollTo = (key) => {
    const map = { work: workRef, about: aboutRef, contact: contactRef };
    if (key === "top") {
      lenisRef.current ? lenisRef.current.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = map[key]?.current;
    if (!el) return;
    if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -80 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  const filterByClient = (client) => {
    setClientFilter(client);
    // give React a tick to render the filter chip before scrolling
    setTimeout(() => scrollTo("work"), 50);
  };

  // Handle hash-based navigation from other pages (/about → /#work)
  useEffect(() => {
    const key = (location.hash || "").replace(/^#/, "");
    if (!key) return;
    // Wait for refs to mount + Lenis to init
    const t = setTimeout(() => scrollTo(key), 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.hash]);

  return (
    <div className="relative bg-void min-h-screen">
      <div className="noise-overlay" />
      <Navbar onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <WorkSection ref={workRef} />
        <About ref={aboutRef} onFilterByClient={filterByClient} />
        <Contact ref={contactRef} />
      </main>
      <Footer onNavigate={scrollTo} />
    </div>
  );
}
